import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { err, ok, Result } from "neverthrow"
import _ from 'lodash'
import { Md5 } from 'ts-md5'
import { fromUint8Array as b64Enc } from 'js-base64'

export function safeDecode(buf: AllowSharedBufferSource|string): Result<string, FusionError> {
	if(_.isString(buf)) {
		return ok(buf)
	}
	try {
		// out of an abundance of caution, wrapped in try block
		// even though i think this is not supposed to throw.
		// by default, decode will not throw an error,
		// it will instead replace invalid bytes invalid bytes with �
		const decoder = new TextDecoder()
		return ok(decoder.decode(buf))
	} catch (ex) {
		return err(serializeFusionError('safeDecode', ex))
	}
}

export function safeContentDigest(buf: Uint8Array, rfc9530value: boolean): Result<string, FusionError> {
	let hashStr: string
	try {
		const hashBytes = new Md5().appendByteArray(buf).end(true)
		if(!(hashBytes instanceof Int32Array)) {
			return err(serializeFusionError('safeHash', 'expected instanceof Int32Array but not'))
		}
		hashStr = b64Enc(new Uint8Array(hashBytes.buffer))
	} catch(ex) {
		return err(serializeFusionError('safeHash', ex))
	}
	if(rfc9530value) {
		return ok(`md5=:${hashStr}:`)
	}
	return ok(hashStr)
}
